import cmsData from "./cms/settings/contact.json";

export const contactInfo = {
  companyName: cmsData.companyName,
  address: cmsData.address,
  phone: cmsData.phone,
  email: cmsData.email,
  facebook: cmsData.facebook,
  linkedin: cmsData.linkedin,
};
